import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { loginAdmin } from '../actions/adminAction';

const Login = ( props: any ) => {


    const [ redirect, setRedirect ] = useState( false );
    const [ phone, setPhone ] = useState( null );
    const [ password, setPassword ] = useState( '' );

    const loginHandler = async ( ) => {

            if ( phone && password ) {
                props.loginAdmin( { phone, password } );
            }
            
    }

    useEffect( ( ) => {

        if ( props.isAuthenticated || localStorage.getItem( 'shreeDevToken' ) as string ) {
            
            setRedirect( true );

        }

    }, [ props.isAuthenticated ] );

    if ( redirect ) {

        return <Redirect to = '/' />
    
    }
    else {
        return (
            <LoginWrapper>
                <div className="login-block">
                    <h1>Shree Developers Admin</h1>
                    <input type="text" placeholder="Phone" id="phone" onChange = { ( e: any ) => setPhone( e.target.value ) } required />
                    <input type="password" placeholder="Password" id="password" onChange = { ( e: any ) => setPassword( e.target.value ) } required />
                    <button disabled = { props.loading } onClick = { loginHandler }>Submit</button>
                    <div className="error-msg">
                        {
                            props.msg
                        }
                    </div>
                </div>
            </LoginWrapper>
        )
    
    }
}


const mapStateToProps = ( state: any ) => ( { 

    isAuthenticated: state.admin.isAuthenticated,
    loading: state.admin.loading,
    msg: state.admin.msg

} );

export default connect( mapStateToProps, {

    loginAdmin

} ) ( Login );


const LoginWrapper = styled.div`

position: absolute;
top: 30%;
left: 50%;
transform: translate( -50%, -50% );

.error-msg {

    padding: 15px 0;
    color: #e40d0d;
    font-weight: bolder;
    text-decoration: underline;
    z-index: 100;
}

.login-block {
    width: 320px;
    padding: 30px;
    background: #fff;
    border-radius: 5px;
    border-top: 8px solid #ff656c;
    margin: 0 auto;
    border-bottom: 4px solid black;
    border-left: 4px solid black;
    border-right: 4px solid black;

}

.login-block h1 {
    text-align: center;
    color: #000;
    font-size: 22px;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 20px;
}

.login-block input {
    width: 100%;
    height: 42px;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: Montserrat;
    padding: 0 20px 0 50px;
    outline: none;
}

.login-block input#username {
    background-size: 16px 80px;
}

.login-block input#username:focus {
    background-size: 16px 80px;
}

.login-block input#password {
    background-size: 16px 80px;
}

.login-block input#password:focus {
    background-size: 16px 80px;
}

.login-block input:active, .login-block input:focus {
    border: 1px solid #ff656c;
}

.login-block button {
    width: 100%;
    height: 40px;
    background: #ff656c;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #e15960;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    font-family: Montserrat;
    outline: none;
    cursor: pointer;
}

.login-block button:hover {
    background: #ff7b81;
}


`;